<template>
  <div>
    <organization-profile-home />
    <events-home />
    <resources-home />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OrganizationProfileHome from "./components/OrganizationProfileHome.vue";
import EventsHome from "./components/EventsHome.vue";
import ResourcesHome from "./components/ResourcesHome.vue";

export default {
  name: "HomePage",
  title: "Profile",
  components: {ResourcesHome, EventsHome, OrganizationProfileHome},
  computed: {
    ...mapGetters({
      user: 'user',
    }),
  },
  mounted() {
    if (this.user.isAdmin) {
      this.$router.push({ name: 'event-list' });
    }
  }
}
</script>

<style scoped>

</style>